import { createAction } from '@reduxjs/toolkit'
import { TGetOneExportTableResponse } from 'redux/api/ExportTables/types'

import { TExportTable } from 'types/GlobalExportTable'

// tryGetAllExportTables
export const getAll = createAction('get_all_export_tables')
export const getAllSuccess = createAction<TExportTable[]>(
  'get_all_export_tables_success'
)
export const getAllFailed = createAction('get_all_export_tables_failed')

// tryGetOneExportTable
export const getOne = createAction<string>('get_one_export_table')
export const getOneSuccess = createAction<TGetOneExportTableResponse>(
  'get_one_export_table_success'
)
export const getOneFailed = createAction<string>('get_one_export_table_failed')

// tryCreateExportTable
export const create = createAction('create_export_table')
export const createSuccess = createAction<TExportTable>(
  'create_export_table_success'
)
export const createFailed = createAction('create_export_table_failed')

// tryUpdateExportTable
export const update = createAction('update_export_table')
export const updateSuccess = createAction<TExportTable>(
  'update_export_table_success'
)
export const updateFailed = createAction('update_export_table_failed')

// tryDeleteExportTable
export const destroy = createAction('delete_export_table')
export const destroySuccess = createAction<string>(
  'delete_export_table_success'
)
export const destroyFailed = createAction('delete_export_table_failed')

// tryGenerateExportTableApiKey
export const assignApiKeys = createAction('assign_api_keys_to_export_table')
export const assignApiKeysSuccess = createAction<{
  id: string
  apiKeys: string[]
}>('assign_api_keys_to_export_table_success')
export const assignApiKeysFailed = createAction(
  'assign_api_keys_to_export_table_failed'
)
